// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2440":"f814ab0e","3439":"f814ab0e","3455":"f814ab0e","5857":"ca29db85","6074":"f814ab0e","8096":"f814ab0e","8543":"f814ab0e","9116":"9f6d047c"}[chunkId] + ".chunk.css";
};